import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// Assinatura digital (ICP-Brasil) do receituário simples com o certificado A1 do profissional.
export function useSignPrescription() {
  const [isSigning, setSigning] = useState(false);

  const sign = useCallback((patientId, prescriptionId, certificatePassword) => {
    setSigning(true);
    return quarkusApi
      .post(
        `/prescriptions/${patientId}/${prescriptionId}/signature`,
        { certificatePassword },
        { headers: { Authorization: sessionStorage.getItem('token') } },
      )
      .finally(() => setSigning(false));
  }, []);

  return { sign, isSigning };
}
